import { RangeSelection } from "../types";
import { Block } from "./block";

interface Builder {
  id: string;
  start: Block | null;
  end: Block | null;
}

export class BlockRange {
  private readonly _id: string;
  private readonly _start: Block | null;
  private readonly _end: Block | null;

  static empty(id: string): BlockRange {
    return new BlockRange({ id, start: null, end: null });
  }

  constructor(builder: Builder) {
    this._id = builder.id;
    this._start = builder.start || null;
    this._end = builder.end || null;
  }

  get id(): string {
    return this._id;
  }

  get start(): Block | null {
    return this._start;
  }

  get end(): Block | null {
    return this._end;
  }

  isEmpty(): boolean {
    return !this.start && !this.end;
  }

  toJSON(): RangeSelection {
    return {
      id: this._id,
      startElementId: this._start?.node?.attrs?.id ?? "",
      endElementId: this._end?.node?.attrs?.id ?? ""
    };
  }
}
